import { FIELD_TYPES } from "constants/template-field-type";
import BannerFieldsConfig from "segments/desktop/core-components/banner/fields-config";
export default {
    type: FIELD_TYPES.NESTED,
    label: "Plain",
    fields: BannerFieldsConfig
};
